export const APP_USER_SESSION = "APP_USER_SESSION";
export const LOCAL_STORAGE = {
  COGNITO: {
    REACT_APP_GW3_MCP_LOGIN_URL: "https://login.dev.mcpayment.net",
    REACT_APP_GW3_COGNITO_POOLS_ID: "ap-southeast-1_TvWSlURSg",
    REACT_APP_GW3_COGNITO_IDP: "REACT_APP_COGNITO_IDP",
  },
};

export const AUTH_STATE = {
  SignedIn: "signedIn",
  InvalidToken: "invalidToken",
  Signout: "signout",
};
